<template>
  <v-container id="uploads-diversos">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form ref="form">
        <PageTitle
          main="Administração"
          icon="mdi-pencil-box-outline"
          sub="Uploads de arquivos diversos"
          home="/administracao"
        />
        <Cadastro />
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Cadastro from '../components/Uploads.vue'
export default {
  name: 'UploadsDiversos',
  components: { PageTitle, Cadastro },
  data: () => ({

  })
}
</script>
